import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [{
		path: '/',
		name: 'usercenter',
		component: () => import('@/views/common/layout.vue'),
		redirect: '/index/index',
		meta: {
			only: true,
			visible: true,
		},
		children: [{
			path: '/index/index',
			name: 'index',
			component: () => import('@/views/index/index.vue'),
			meta: {
				title: '概况中心',
				visible: true,
				icon: "center-icon",
			}
		}]
	}, {
		path: '/',
		name: 'user',
		meta: {
			title: '个人中心',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/user/info',
			name: 'info',
			component: () => import('@/views/user/info.vue'),
			meta: {
				title: '个人信息',
				visible: true,
			},
		}, {
			path: '/user/message',
			name: 'message',
			component: () => import('@/views/user/message.vue'),
			meta: {
				title: '消息列表',
				visible: true,
			},
		}, {
			path: '/user/list',
			name: 'userlist',
			component: () => import('@/views/user/list.vue'),
			meta: {
				title: '角色人员列表',
				visible: true,
			},
		},{
			path: '/user/userList',
			name: 'userlist',
			component: () => import('@/views/user/userList.vue'),
			meta: {
				title: '用户列表',
				visible: true,
			},
		}]
	},{
		path: '/',
		name: 'food',
		meta: {
			title: 'banner管理',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/food/foodCate',
			name: 'footCate',
			component: () => import('@/views/food/foodCate.vue'),
			meta: {
				title: '菜品分类列表',
				visible: true,
			},
		},{
			path: '/food/foodList',
			name: 'foodList',
			component: () => import('@/views/food/foodList.vue'),
			meta: {
				title: 'banner列表',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'announcement',
		meta: {
			title: '公告管理',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/announcement/announcementList',
			name: 'footCate',
			component: () => import('@/views/announcement/announcementList.vue'),
			meta: {
				title: '公告列表',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'propertyMaintenance',
		meta: {
			title: '物业报修',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/propertyMaintenance/propertyMaintenanceList',
			name: 'propertyMaintenanceList',
			component: () => import('@/views/propertyMaintenance/propertyMaintenanceList.vue'),
			meta: {
				title: '物业报修',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'building',
		meta: {
			title: '楼宇管理',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/building/buildingList',
			name: 'buildingList',
			component: () => import('@/views/building/buildingList.vue'),
			meta: {
				title: '楼宇列表',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'maintenance',
		meta: {
			title: '维修管理',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/maintenance/maintenanceTypeList',
			name: 'maintenanceTypeList',
			component: () => import('@/views/maintenance/maintenanceTypeList.vue'),
			meta: {
				title: '维修类型',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'visitor',
		meta: {
			title: '访客信息管理',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/visitor/visitorList',
			name: 'visitorList',
			component: () => import('@/views/visitor/visitorList.vue'),
			meta: {
				title: '访客信息列表',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'qrcode',
		meta: {
			title: '二维码管理',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/qrcode/freeExitQrcode',
			name: 'freeExitQrcode',
			component: () => import('@/views/qrcode/freeExitQrcode.vue'),
			meta: {
				title: '免费出场二维码',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'parking',
		meta: {
			title: '停车管理',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/parking/freeExitRecordList',
			name: 'freeExitRecordList',
			component: () => import('@/views/parking/freeExitRecordList.vue'),
			meta: {
				title: '免费出场记录',
				visible: true,
			},
		}]
	},{
		path: '/',
		name: 'system',
		meta: {
			title: '系统管理',
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/system/admin',
			name: 'admin',
			component: () => import('@/views/system/admin.vue'),
			meta: {
				title: '管理员管理',
				visible: true,
			},
		}, {
			path: '/system/role',
			name: 'role',
			component: () => import('@/views/system/role.vue'),
			meta: {
				title: '角色管理',
				visible: true,
			},
		}, {
			path: '/system/menu',
			name: 'menu',
			component: () => import('@/views/system/menu.vue'),
			meta: {
				title: '菜单管理',
				visible: true,
			},
		}, {
			path: '/system/option',
			name: 'option',
			component: () => import('@/views/system/option.vue'),
			meta: {
				title: '操作权限管理',
				visible: true,
			},
		}, {
			path: '/system/viprule',
			name: 'business',
			component: () => import('@/views/system/viprule.vue'),
			meta: {
				title: '会员等级管理',
				visible: true
			},
		}, {
			path: '/system/params',
			name: 'params',
			component: () => import('@/views/system/params.vue'),
			meta: {
				title: '参数管理',
				visible: true
			},
		}, {
			path: '/system/log',
			name: 'log',
			component: () => import('@/views/system/log.vue'),
			meta: {
				title: '操作日志',
				visible: true
			},
		}]
	}, {
		path: '/',
		name: 'goods',
		meta: {
			title: '商品中心',
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/goods/goods',
			name: 'goods',
			component: () => import('@/views/goods/goods.vue'),
			meta: {
				title: '商品列表',
				visible: true,
			},
		}, {
			path: '/goods/categoryfore',
			name: 'categoryfore',
			component: () => import('@/views/goods/categoryfore.vue'),
			meta: {
				title: '分类管理',
				visible: true,
			},
		}, {
			path: '/goods/channel',
			name: 'channel',
			component: () => import('@/views/goods/channel.vue'),
			meta: {
				title: '频道管理',
				visible: true,
			},
		}, {
			path: '/goods/channelgoods',
			name: 'channelgoods',
			component: () => import('@/views/goods/channelgoods.vue'),
			meta: {
				title: '频道商品管理',
				visible: false,
			},
		}, {
			path: '/goods/goodsgroup',
			name: 'goodsgroup',
			component: () => import('@/views/goods/goodsgroup.vue'),
			meta: {
				title: '商品组列表',
				visible: false,
			},
		}]
	}, {
		path: '/',
		name: 'stock',
		meta: {
			title: '库存管理',
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/stock/list',
			name: 'stocklist',
			component: () => import('@/views/stock/list.vue'),
			meta: {
				title: '库存列表',
				visible: true,
			},
		}, {
			path: '/stock/stocklog',
			name: 'stocklist',
			component: () => import('@/views/stock/stocklog.vue'),
			meta: {
				title: '库存日志',
				visible: true,
			},
		}, {
			path: '/stock/stockinput',
			name: 'stockinput',
			component: () => import('@/views/stock/stockinput.vue'),
			meta: {
				title: '入库列表',
				visible: true,
			},
		}, {
			path: '/stock/stockoutput',
			name: 'stockoutput',
			component: () => import('@/views/stock/stockoutput.vue'),
			meta: {
				title: '出库列表',
				visible: true,
			},
		}, {
			path: '/stock/stockallot',
			name: 'stockallot',
			component: () => import('@/views/stock/stockallot.vue'),
			meta: {
				title: '调拨列表',
				visible: true,
			},
		}, {
			path: '/stock/stockreset',
			name: 'stockreset',
			component: () => import('@/views/stock/stockreset.vue'),
			meta: {
				title: '盘点列表',
				visible: true,
			},
		}, {
			path: '/stock/stockproduct',
			name: 'stockproduct',
			component: () => import('@/views/stock/stockproduct.vue'),
			meta: {
				title: '库存商品管理',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'customer',
		meta: {
			title: '客户管理',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/customer/company',
			name: 'company',
			component: () => import('@/views/customer/company.vue'),
			meta: {
				title: '店铺管理',
				visible: true
			},
		}, {
			path: '/customer/account',
			name: 'account',
			component: () => import('@/views/customer/account.vue'),
			meta: {
				title: '店铺管理员管理',
				visible: true
			},
		}, {
			path: '/customer/business',
			name: 'business',
			component: () => import('@/views/customer/business.vue'),
			meta: {
				title: '店铺管理',
				visible: true
			},
		}, {
			path: '/customer/supplier',
			name: 'supplier',
			component: () => import('@/views/customer/supplier.vue'),
			meta: {
				title: '供应商管理',
				visible: true
			},
		}, {
			path: '/customer/feedback',
			name: 'feedback',
			component: () => import('@/views/customer/feedbackManage.vue'),
			meta: {
				title: '意见反馈',
				visible: true
			},
		}, {
			path: '/customer/addrlist',
			name: 'addrlist',
			component: () => import('@/views/customer/addrlist.vue'),
			meta: {
				title: '用户地址',
				visible: true
			},
		}]
	},{
		path: '/',
		name: 'order',
		meta: {
			title: '订单管理',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/order/orderdeal',
			name: 'orderdeal',
			component: () => import('@/views/order/orderdeal.vue'),
			meta: {
				title: '待完成列表',
				visible: true,
			},
		}, {
			path: '/order/orderlist',
			name: 'orderlist',
			component: () => import('@/views/order/orderlist.vue'),
			meta: {
				title: '订单列表',
				visible: true,
			},
		}, {
			path: '/order/ordersum',
			name: 'orderlist',
			component: () => import('@/views/order/ordersum.vue'),
			meta: {
				title: '订单汇总',
				visible: true,
			},
		},  {
			path: '/order/orderitems',
			name: 'orderlist',
			component: () => import('@/views/order/orderitems.vue'),
			meta: {
				title: '订单汇总',
				visible: true,
			},
		}, {
			path: '/order/userorder',
			name: 'userorder',
			component: () => import('@/views/order/userorder.vue'),
			meta: {
				title: '点单详情',
				visible: false,
			},
		}]
	}, {
		path: '/',
		name: 'equipment',
		meta: {
			title: '设备管理',
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/equipment/printer',
			name: 'printer',
			component: () => import('@/views/equipment/printer.vue'),
			meta: {
				title: '打印机管理',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'banner',
		meta: {
			title: '首页管理管理',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/banner/actbanner',
			name: 'actbanner',
			component: () => import('@/views/banner/actbanner.vue'),
			meta: {
				title: '首页banner',
				visible: true,
			},
		},{
			path: '/topnav/list',
			name: 'topnav',
			component: () => import('@/views/topnav/list.vue'),
			meta: {
				title: '首页导航',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'bill',
		meta: {
			title: '账单管理',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/bill/companybill',
			name: 'companybill',
			component: () => import('@/views/bill/companybill.vue'),
			meta: {
				title: '店铺账单',
				visible: true,
			},
		}, {
			path: '/bill/personalbill',
			name: 'personalbill',
			component: () => import('@/views/bill/personalbill.vue'),
			meta: {
				title: '店铺账单',
				visible: true,
			},
		}, {
			path: '/bill/companydetail',
			name: 'companydetail',
			component: () => import('@/views/bill/companydetail.vue'),
			meta: {
				title: '店铺账单明细',
				visible: false,
			},
		}, {
			path: '/bill/personaldetail',
			name: 'personaldetail',
			component: () => import('@/views/bill/personaldetail.vue'),
			meta: {
				title: '个人账单明细',
				visible: false,
			},
		}]
	}, {
		path: '/',
		name: 'payment',
		meta: {
			title: '支付管理',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/payment/balance',
			name: 'balance',
			component: () => import('@/views/payment/balance.vue'),
			meta: {
				title: '余额明细',
				visible: true
			},
		}, {
			path: '/payment/payrecords',
			name: 'balance',
			component: () => import('@/views/payment/payrecords.vue'),
			meta: {
				title: '交易记录',
				visible: true
			},
		}, {
			path: '/payment/refundrecords',
			name: 'balance',
			component: () => import('@/views/payment/refundrecords.vue'),
			meta: {
				title: '退款记录',
				visible: true
			},
		}]
	}, {
		path: '/',
		name: 'order',
		meta: {
			title: '定制管理',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/custom/customer',
			name: 'customer',
			component: () => import('@/views/custom/customer.vue'),
			meta: {
				title: '客户管理',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'cooperation',
		meta: {
			title: '合作申请',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/cooperation/orderApply',
			name: 'company',
			component: () => import('@/views/cooperation/orderApply.vue'),
			meta: {
				title: '下单申请',
				visible: true
			},
		}, {
			path: '/cooperation/enterApply',
			name: 'account',
			component: () => import('@/views/cooperation/enterApply.vue'),
			meta: {
				title: '加盟申请',
				visible: true
			},
		}]
	}, {
		path: '/',
		name: 'news',
		meta: {
			title: '系统设置',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/setting/work',
			name: 'company',
			component: () => import('@/views/setting/work.vue'),
			meta: {
				title: '排班调度',
				visible: true
			},
		}]
	}, {
		path: '/',
		name: 'news',
		meta: {
			title: '新闻公告',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/webnews/newslist',
			name: 'company',
			component: () => import('@/views/webnews/newslist.vue'),
			meta: {
				title: '新闻管理',
				visible: true
			},
		}, {
			path: '/webnews/noticelist',
			name: 'company',
			component: () => import('@/views/webnews/noticelist.vue'),
			meta: {
				title: '公告管理',
				visible: true
			},
		}]
	},
		{
			path: '/',
			name: 'common',
			meta: {
				// only: true,
				// icon: 'el-icon-goods',
				visible: false,
			},
			component: () => import('@/views/common/layout.vue'),
			children: [{
				path: '/error',
				name: 'error',
				meta: {
					title: '错误页面',
					visible: false,
				},
				component: () => import('@/views/error/index')
			}],
		},
		{
			path: '/login',
			name: 'login',
			meta: {
				title: '登录',
			},
			component: () => import('@/views/account/login')
		},{
			path: '/',
			name: 'join',
			meta: {
				title: '商家管理',
				// icon: 'el-icon-goods',
				icon: "user-icon",
				visible: true,
			},
			component: () => import('@/views/common/layout.vue'),
			children: [{
				path: '/join/business',
				name: 'joinbusiness',
				component: () => import('@/views/join/business.vue'),
				meta: {
					title: '商家店铺管理',
					visible: true
				},
			}, {
				path: '/join/goodsgroup',
				name: 'joingoodsgroup',
				component: () => import('@/views/join/goodsgroup.vue'),
				meta: {
					title: '商家商品分类管理',
					visible: true
				},
			}, {
				path: '/join/goods',
				name: 'joingoods',
				component: () => import('@/views/join/goods.vue'),
				meta: {
					title: '商家商品管理',
					visible: true
				},
			}, {
				path: '/join/channel',
				name: 'joinchannel',
				component: () => import('@/views/join/channel.vue'),
				meta: {
					title: '商家频道管理',
					visible: true
				},
			}, {
				path: '/join/channelgoods',
				name: 'joinchannelgoods',
				component: () => import('@/views/join/channelgoods.vue'),
				meta: {
					title: '商家频道商品管理',
					visible: true
				},
			}, {
				path: '/join/users',
				name: 'joinusers',
				component: () => import('@/views/join/users.vue'),
				meta: {
					title: '商家用户管理',
					visible: true
				},
			}]
		},{
			path: '/',
			name: 'joinorder',
			meta: {
				title: '商家订单管理',
				icon: "user-icon",
				visible: true,
			},
			component: () => import('@/views/common/layout.vue'),
			children: [{
				path: '/join/orderdeal',
				name: 'joinorderdeal',
				component: () => import('@/views/join/orderdeal.vue'),
				meta: {
					title: '待完成订单',
					visible: true
				},
			}, {
				path: '/join/orderlist',
				name: 'joinorderlist',
				component: () => import('@/views/join/orderlist.vue'),
				meta: {
					title: '已完成订单',
					visible: true
				},
			}]
		},{
			path: '/',
			name: 'joinbill',
			meta: {
				title: '商家账单管理',
				icon: "user-icon",
				visible: true,
			},
			component: () => import('@/views/common/layout.vue'),
			children: [{
				path: '/join/companybill',
				name: 'joincompanybill',
				component: () => import('@/views/join/companybill.vue'),
				meta: {
					title: '待完成订单',
					visible: true
				},
			}]
		},{
			path: '/',
			name: 'supplier',
			meta: {
				title: '供应商管理',
				icon: "user-icon",
				visible: true,
			},
			component: () => import('@/views/common/layout.vue'),
			children: [{
				path: '/supplier/datastatis',
				name: 'supplierdatastatis',
				component: () => import('@/views/supplier/datastatis.vue'),
				meta: {
					title: '供应商信息设置',
					visible: true
				},
			},{
				path: '/supplier/supplier',
				name: 'suppliersupplier',
				component: () => import('@/views/supplier/supplier.vue'),
				meta: {
					title: '供应商信息设置',
					visible: true
				},
			},{
				path: '/supplier/goods',
				name: 'suppliergoods',
				component: () => import('@/views/supplier/goods.vue'),
				meta: {
					title: '供应商产品管理',
					visible: true
				},
			},{
				path: '/supplier/orderitems',
				name: 'supplierorderitems',
				component: () => import('@/views/supplier/orderitems.vue'),
				meta: {
					title: '产品供应商列表',
					visible: true
				},
			}]
		},{
			path: '/',
			name: 'businessManagement',
			meta: {
				title: '业务管理',
				icon: "user-icon",
				visible: true,
			},
			component: () => import('@/views/common/layout.vue'),
			children: [{
				path: '/businessTraveler/travelerList',
				name: 'travelerList',
				component: () => import('@/views/businessTraveler/travelerList.vue'),
				meta: {
					title: '出差人员信息',
					visible: true
				},
			}, {
				path: '/paymentRule/paymentRuleList',
				name: 'paymentRuleList',
				component: () => import('@/views/paymentRule/paymentRuleList.vue'),
				meta: {
					title: '支付规则',
					visible: true
				},
			}, {
				path: '/orderRecord/orderRecordList',
				name: 'orderRecordList',
				component: () => import('@/views/orderRecord/orderRecordList.vue'),
				meta: {
					title: '订单记录',
					visible: true
				},
			}]
		}, {
			path: '/',
			name: 'mealRecharge',
			meta: {
				title: '餐费管理',
				icon: "user-icon",
				visible: true,
			},
			component: () => import('@/views/common/layout.vue'),
			children: [{
				path: '/mealRecharge/recordList',
				name: 'mealRechargeRecordList',
				component: () => import('@/views/mealRecharge/recordList.vue'),
				meta: {
					title: '餐费充值记录',
					visible: true
				},
			}]
		}
	]
})
